import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserFragmentDoc } from './user';

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type ProjectFragment = { __typename?: 'Project', id: string, code: string, status?: Types.ProjectStatusEnum | null, sector?: string | null, created_at?: number | null, updated_at?: number | null, name?: string | null, background_info?: string | null, background?: { __typename?: 'File', base64: string, path: string, filename: string, width?: number | null, height?: number | null, type: string, size: number } | null, schema?: { __typename?: 'File', filename: string, path: string } | null, preview?: { __typename?: 'File', filename: string, path: string } | null, user?: { __typename?: 'User', id: string, name?: string | null, city?: string | null, email: string, active: boolean, company?: string | null, is_admin: boolean } | null };

export const ProjectFragmentDoc = gql`
    fragment project on Project {
  id
  code
  status
  sector
  created_at
  updated_at
  name
  background {
    base64
    path
    filename
    width
    height
    type
    size
  }
  background_info
  schema {
    filename
    path
  }
  preview {
    filename
    path
  }
  user {
    ...user
  }
}
    ${UserFragmentDoc}`;